import { IUser } from './../../../shared/models/user.model';
import { EventsService } from './../../../shared/services/events/events.service';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { VariablesService, SeoService } from '../../../shared/services';
import { UtilService } from '../../../shared/services/util/util.service';
// import * as algoliasearch from 'algoliasearch/lite';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';
import { Subscription } from 'rxjs';
import { CATEGORIES } from '../filter.model';

@Component({
  selector: 'app-browse-container',
  templateUrl: './browse-container.component.html',
  styleUrls: ['./browse-container.component.scss']
})
export class BrowseContainerComponent implements OnInit, OnDestroy {

  isMobile: any;
  appliedFilters;
  currency;
  currencyIcon;
  fundraisers = [];
  isLoggedIn;
  myFundraisersLink;
  toggleFilterComponent = false;
  filterValues;
  onLoadCause = '';
  onLoadTag = 'Trending';
  // algoliaConfig;
  // meilisearchConfig;
  instantSearchConfig;
  searchClient;
  showPlaceholder = true;
  query;
  metaData;
  tags;
  generalSubs: Subscription[] = [];
  user: IUser;
  loginPopupState = false;

  constructor(
    @Inject(DOCUMENT) public document: any,
    private util: UtilService,
    private vars: VariablesService,
    private actRoute: ActivatedRoute,
    private seoService: SeoService,
    private events: EventsService
  ) {
    this.getParam();
  }

  ngOnInit() {
    // this.onLoadTag = ''; // for test only
    this.isMobile = this.util.isMobile();
    this.vars.pageName = 'browse_fundraisers';
    this.addMetaTags();
    this.vars.mainLayoutConfig.next({
      showHeader: true,
      showFooter: true,
      showMenus: true,
      showProfile: true,
      showSearch: true,
      logoNavigate: true,
      animateHeader: false,
      zendesk: true,
      hideAbandonedCart: false,
      headerTopSticky: false
    });
    this.filterValues = {
      'cause': this.onLoadCause || 'All Categories',
      'tags': this.onLoadTag || 'All Types',
      'address': 'All Locations'
    };
    this.generalSubs.push(
      this.vars.appliedFilters.subscribe((res: any) => {
        this.appliedFilters = res;
      })
    );
    this.generalSubs.push(
      this.vars.userData.subscribe((res: any) => {
        this.user = res;
      })
    );
    this.getCurrency();

    // this.searchClient = algoliasearch(environment.algolia.id, environment.algolia.key);
    this.searchClient = instantMeiliSearch(environment.meilisearch.host, environment.meilisearch.key);

    this.instantSearchConfig = {
      searchClient: this.searchClient,
      indexName: environment.meilisearch.index,
      initialUiState: {
        [environment.meilisearch.index]: {
          query: this.query,
          menu: {
            category: this.onLoadCause,
            tags: this.onLoadTag
          }
        }
      }
    };

    this.actRoute.queryParams.subscribe((param) => {
      this.query = param['query'] || '';
    });
    this.seoService.updateCanonicalURL('/crowdfunding/fundraisers');
    this.events.onLoadSystemEvent({
      eventName: 'pageview',
      page_name: this.vars.pageName,
    });

    if (this.util.isBrowser) {
      const focus = this.actRoute.snapshot.queryParams['focus'] || '';
      if (focus?.match('top')) {
          this.util.scrollToTop('instant');
      } else {
        setTimeout(() => {
          this.util.scrollIntoViewSmoothly(focus);
        }, 500);
      }
      if (!focus) {
        setTimeout(() => {
          this.util.scrollToTop();
        }, 1100);
      }
    }
  }

  addMetaTags() {
    this.metaData = this.seoService.crowdfundingFundraiserMetaTags();
    this.tags = this.seoService.createTagObject(this.metaData);
    this.seoService.addMetaTags(this.tags);
    this.util.setPageTitle(`Fundraisers | Contribute Money Online to Help Needy`);
  }

  getParam() {
    this.actRoute.queryParams.subscribe((params) => {
      /**If redirected form homepage, set the origin cause by default */
      const cause = this.capitalizeFirstLetter(params['cause']);
      CATEGORIES.forEach(element => {
        if (element.value === cause) {
          this.onLoadCause = cause;
        }
      });
      this.query = params['query'];
      /**If a origin cause is set by default, remove trending tag */
      if (params['cause'] || params['query']) {
        this.onLoadTag = '';
      }
    });
  }

  capitalizeFirstLetter(string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }


  /**Scroll window to top when mobile filters are opened and freeze background */
  toggleFilterFunction(event) {
    window.scrollTo({ left: 0, top: 0 });
    const elem: HTMLElement = this.document.getElementsByTagName('body')[0];
    this.toggleFilterComponent = event;
    if (event) {
      elem.setAttribute('style', 'overflow:hidden');
    } else {
      elem.setAttribute('style', 'overflow:auto');
    }
  }

  getCurrency() {
    this.util.currency.subscribe((res) => {
      if (res) {
        this.currency = res;
        this.currencyIcon = this.util.getCurrencyIcon(res);
      }
    });
  }

  // /**Event listener function to hide the tooltips on widget */
  // hideAllTaxTooltips(data) {
  //   this.fundraisers.forEach((element: any) => {
  //     element.hideTaxTooltip = true;
  //   });
  // }

  /**Check if data is available to toggle placeholder */
  checkData(hits) {
    if (hits && hits.length && this.showPlaceholder) {
      setTimeout(() => {
        this.showPlaceholder = false;
      }, 0);
    }
    return typeof (hits);
  }

  ngOnDestroy() {
    this.generalSubs.forEach(s => s.unsubscribe());
  }

  openLoginPopup(event) {
    this.loginPopupState = true;
    const ePayload = {
      eventName: 'login_btn_click',
      info_1: event
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }

  signinClosed(event) {
    this.loginPopupState = false;
  }

}
